import IntraserLogo from 'assets/icons/tenant/intraser-blue.svg';
import XPOLogo from 'assets/icons/xpo/xpo-logo.jpg';
import RPTLogo from 'assets/icons/rpt/rpt-logo.jpg';
import OntruckLogo from 'assets/icons/ontruck-logo.svg';
import CEXLogo from 'assets/icons/cex/cex-logo.svg';
import OnTimeLogo from 'assets/icons/ontime/ontime-logo.svg';
import AlianzaLogo from 'assets/icons/alianza/alianza-logo.svg';
import { TENANTS_NAMES } from 'tenant/host_config';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

export const LoginIcon = () => {
  const iconConfig = getTenantPreLoginConfig().login_icon;
  const Icons = {
    [TENANTS_NAMES.intraser]: IntraserLogo,
    [TENANTS_NAMES.xpo]: XPOLogo,
    [TENANTS_NAMES.ontruck]: OntruckLogo,
    [TENANTS_NAMES.rpt]: RPTLogo,
    [TENANTS_NAMES.cex]: CEXLogo,
    [TENANTS_NAMES.ontime]: OnTimeLogo,
    [TENANTS_NAMES.alianza]: AlianzaLogo,
  };
  return Icons[iconConfig];
};
